// Opciones y normalización compartidas por el alta de clientes (ClientModal y la bienvenida)

export const SECTOR_OPTIONS = [
  { value: "restauracion", label: "Restauración" },
  { value: "retail", label: "Retail / Comercio" },
  { value: "servicios", label: "Servicios Profesionales" },
  { value: "salud", label: "Salud y Bienestar" },
  { value: "tecnologia", label: "Tecnología" },
  { value: "educacion", label: "Educación" },
  { value: "inmobiliario", label: "Inmobiliario" },
  { value: "turismo", label: "Turismo y Hostelería" },
  { value: "automocion", label: "Automoción" },
];

export const SETUP_OPTIONS = [
  {
    value: true,
    title: "Sí, usar el Setup recomendado",
    description: "El Setup arranca con todas las fases listas para trabajar y visible para el cliente.",
  },
  {
    value: false,
    title: "No, prefiero no utilizarlo por ahora",
    description: "El Setup queda como “No necesario” y oculto para el cliente hasta que lo activéis.",
  },
];

export const INVALID_URL_MESSAGE = "Introduce una URL válida (ej.: https://miweb.com)";

export const normalizeUrlWithHttps = (url) => {
  let normalized = (url || "").trim();
  if (!normalized) return "";
  if (normalized.toLowerCase().startsWith("https://")) return normalized;
  if (normalized.toLowerCase().startsWith("http://")) {
    normalized = normalized.slice("http://".length);
  }
  return `https://${normalized.replace(/^\/\//, "")}`;
};

export const validateUrlFormat = (url) => {
  if (!url?.trim()) return null;
  const normalizedUrl = normalizeUrlWithHttps(url);
  if (!normalizedUrl.replace(/^https?:\/\//i, "").includes(".")) return INVALID_URL_MESSAGE;
  if (normalizedUrl.length > 200) return "La URL no puede superar los 200 caracteres";
  return null;
};
